<template>
  <div
    class="form-checkbox control-group"
    :class="{ error: error }"
  >
    <span class="control-label form-checkbox__label">
      <abbr
        v-if="required"
        title="Verplicht veld"
      >
        *
      </abbr>
      {{ label }}
    </span>
    <div class="form-checkbox__options">
      <label
        v-for="option in options"
        :key="option"
        class="form-radio__option"
      >
        <input
          v-model="state"
          type="checkbox"
          :value="option"
        >
        <span>
          {{ option | formatBoolean }}
        </span>
      </label>
    </div>
    <span
      v-if="error && error.input"
      class="help-inline"
    >
      {{ error.input }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'FormCheckbox',

  schema: [
    {
      name: 'label',
      default: 'Label',
      type: 'FormText',
      label: 'Label',
    },
    {
      name: 'options',
      default: [],
      type: 'FormChips',
      label: 'Opties',
    },
    {
      name: 'required',
      default: false,
      type: 'FormCheckbox',
      label: 'Verplicht',
    },
  ],

  filters: {
    formatBoolean(val) {
      return val === true ? 'Ja' : val;
    },
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [true],
    },
    value: {
      type: [Array, Boolean],
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => (null),
    },
  },

  computed: {
    state: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">
.form-checkbox {
  display: flex;
  flex-grow: 1;

  &__label.control-label {
    width: 50%;
    font-size: 14px;
    line-height: 30px;
    // margin-right: 20px;
    padding-left: 40px;
    text-align: left;
  }

  &__options {
    width: 50%;
    // margin-right: 10px;
  }

  &__option {
    align-items: center;
    display: flex;
    line-height: 20px;
    text-overflow: ellipsis;
    overflow: hidden;
    // margin-right: 10px;

    input {
      margin: 0 5px 0 0;
    }
  }
}
</style>
